import { Switch } from "antd";
import React from "react";
import { useFormContext } from "react-hook-form";
import { Controller } from "react-hook-form";
import { TBanquetForm } from "../../types";
import { Wrapper } from "./styled";
import { Translater } from "../../../../config";
import * as Contexts from "../../../../contexts";
import { useContext } from "react";

export const CkeckBox = () => {
  const { control } = useFormContext<TBanquetForm>();
  const { language } = useContext(Contexts.LanguageContext);
  return (
    <Wrapper>
      <p>{Translater.Landings.Banquet.showSection[language.slug]}</p>
      <Controller
        name="isActive"
        control={control}
        defaultValue={false}
        render={({ value, onChange }) => (
          <Switch checked={value} onClick={(e) => onChange(!value)} />
        )}
      />
    </Wrapper>
  );
};
